import React from "react";

const TrendBars = ({ rows = [], formatValue }) => {
  if (!rows.length) return null;
  const max = Math.max(1, ...rows.map((r) => Number(r.value ?? 0)));
  return (
    <div className="trend">
      {rows.map((r, i) => {
        const value = Number(r.value ?? 0);
        const heightPct = Math.max(2, (value / max) * 100);
        const title = formatValue ? formatValue(value) : String(value);
        return (
          <div className="trend__bar" key={r.key ?? r.label ?? i}>
            <div className="trend__fill" style={{ height: `${heightPct}%` }} title={title} />
            <div className="trend__month">{r.label}</div>
          </div>
        );
      })}
    </div>
  );
};

export default TrendBars;
